// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Zero.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Main-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Main-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Math-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Main-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Math-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size1-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size2-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size3-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size4-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_AMS-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Calligraphic-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Calligraphic-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Fraktur-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Fraktur-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_SansSerif-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_SansSerif-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_SansSerif-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Script-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Typewriter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Vector-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Vector-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */

@font-face /* 0 */ {
  font-display: swap;
  font-family: MJXZERO;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format('woff');
}

@font-face /* 1 */ {
  font-display: swap;
  font-family: MJXTEX;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format('woff');
}

@font-face /* 2 */ {
  font-display: swap;
  font-family: MJXTEX-B;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format('woff');
}

@font-face /* 3 */ {
  font-display: swap;
  font-family: MJXTEX-I;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
    format('woff');
}

@font-face /* 4 */ {
  font-display: swap;
  font-family: MJXTEX-MI;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
    format('woff');
}

@font-face /* 5 */ {
  font-display: swap;
  font-family: MJXTEX-BI;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format('woff');
}

@font-face /* 6 */ {
  font-display: swap;
  font-family: 'MJXTEX-S1';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
    format('woff');
}

@font-face /* 7 */ {
  font-display: swap;
  font-family: 'MJXTEX-S2';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
    format('woff');
}

@font-face /* 8 */ {
  font-display: swap;
  font-family: 'MJXTEX-S3';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
    format('woff');
}

@font-face /* 9 */ {
  font-display: swap;
  font-family: 'MJXTEX-S4';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
    format('woff');
}

@font-face /* 10 */ {
  font-display: swap;
  font-family: MJXTEX-A;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___})
    format('woff');
}

@font-face /* 11 */ {
  font-display: swap;
  font-family: MJXTEX-C;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    format('woff');
}

@font-face /* 12 */ {
  font-display: swap;
  font-family: MJXTEX-CB;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___})
    format('woff');
}

@font-face /* 13 */ {
  font-display: swap;
  font-family: MJXTEX-FR;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___})
    format('woff');
}

@font-face /* 14 */ {
  font-display: swap;
  font-family: MJXTEX-FRB;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___})
    format('woff');
}

@font-face /* 15 */ {
  font-display: swap;
  font-family: MJXTEX-SS;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___})
    format('woff');
}

@font-face /* 16 */ {
  font-display: swap;
  font-family: MJXTEX-SSB;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___})
    format('woff');
}

@font-face /* 17 */ {
  font-family: MJXTEX-SSI;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___})
    format('woff');
}

@font-face /* 18 */ {
  font-display: swap;
  font-family: MJXTEX-SC;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___})
    format('woff');
}

@font-face /* 19 */ {
  font-display: swap;
  font-family: MJXTEX-T;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___})
    format('woff');
}

@font-face /* 20 */ {
  font-display: swap;
  font-family: MJXTEX-V;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___})
    format('woff');
}

@font-face /* 21 */ {
  font-display: swap;
  font-family: MJXTEX-VB;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___})
    format('woff');
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/mathjax-extension/style/fonts.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,kBAAkB;EAClB,oBAAoB;EACpB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;kBACgB;AAClB;;AAEA;EACE,uBAAuB;EACvB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;kBACgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB;kBACgB;AAClB","sourcesContent":["/*\n * Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n\n@font-face /* 0 */ {\n  font-display: swap;\n  font-family: MJXZERO;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Zero.woff')\n    format('woff');\n}\n\n@font-face /* 1 */ {\n  font-display: swap;\n  font-family: MJXTEX;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Main-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 2 */ {\n  font-display: swap;\n  font-family: MJXTEX-B;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Main-Bold.woff')\n    format('woff');\n}\n\n@font-face /* 3 */ {\n  font-display: swap;\n  font-family: MJXTEX-I;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Math-Italic.woff')\n    format('woff');\n}\n\n@font-face /* 4 */ {\n  font-display: swap;\n  font-family: MJXTEX-MI;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Main-Italic.woff')\n    format('woff');\n}\n\n@font-face /* 5 */ {\n  font-display: swap;\n  font-family: MJXTEX-BI;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Math-BoldItalic.woff')\n    format('woff');\n}\n\n@font-face /* 6 */ {\n  font-display: swap;\n  font-family: 'MJXTEX-S1';\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size1-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 7 */ {\n  font-display: swap;\n  font-family: 'MJXTEX-S2';\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size2-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 8 */ {\n  font-display: swap;\n  font-family: 'MJXTEX-S3';\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size3-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 9 */ {\n  font-display: swap;\n  font-family: 'MJXTEX-S4';\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Size4-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 10 */ {\n  font-display: swap;\n  font-family: MJXTEX-A;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_AMS-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 11 */ {\n  font-display: swap;\n  font-family: MJXTEX-C;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Calligraphic-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 12 */ {\n  font-display: swap;\n  font-family: MJXTEX-CB;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Calligraphic-Bold.woff')\n    format('woff');\n}\n\n@font-face /* 13 */ {\n  font-display: swap;\n  font-family: MJXTEX-FR;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Fraktur-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 14 */ {\n  font-display: swap;\n  font-family: MJXTEX-FRB;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Fraktur-Bold.woff')\n    format('woff');\n}\n\n@font-face /* 15 */ {\n  font-display: swap;\n  font-family: MJXTEX-SS;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_SansSerif-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 16 */ {\n  font-display: swap;\n  font-family: MJXTEX-SSB;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_SansSerif-Bold.woff')\n    format('woff');\n}\n\n@font-face /* 17 */ {\n  font-family: MJXTEX-SSI;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_SansSerif-Italic.woff')\n    format('woff');\n}\n\n@font-face /* 18 */ {\n  font-display: swap;\n  font-family: MJXTEX-SC;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Script-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 19 */ {\n  font-display: swap;\n  font-family: MJXTEX-T;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Typewriter-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 20 */ {\n  font-display: swap;\n  font-family: MJXTEX-V;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Vector-Regular.woff')\n    format('woff');\n}\n\n@font-face /* 21 */ {\n  font-display: swap;\n  font-family: MJXTEX-VB;\n  src: url('~mathjax-full/es5/output/chtml/fonts/woff-v2/MathJax_Vector-Bold.woff')\n    format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
